export default {
  'riskControl': {
    'common': {
      'search': 'Search',
      'reset': 'Reset',
      'submit': 'Submit',
      'cancel': 'Cancel',
      'confirm': 'Confirm',
      'operation': 'Operation',
      'status': 'Status',
      'createTime': 'Create Time',
      'updateTime': 'Update Time',
      'remark': 'Remark',
      'amount': 'Amount',
      'currency': 'Currency',
      'orderNumber': 'Order Number',
      'memberAccount': 'Member Account',
      'fee': 'Fee',
      'type': 'Type',
      'all': 'All',
      'pending': 'Pending',
      'processing': 'Processing',
      'completed': 'Completed',
      'failed': 'Failed',
      'rejected': 'Rejected',
      'approved': 'Approved',
      'locked': 'Locked',
      'unlocked': 'Unlocked',
      'dateRange': 'Date Range',
      'startDate': 'Start Date',
      'endDate': 'End Date',
      'dateType': 'Date Type',
      'dateType.createTime': 'Create Time',
      'dateType.updateTime': 'Update Time',
      'dateType.completeTime': 'Complete Time',
      'dateType.applyTime': 'Apply Time',
      'dateType.successTime': 'Success Time',
      'noData': 'No Data',
      'total': 'Total {total} Items',
    },
    'withdrawal': {
      'title': 'Withdrawal Risk Control',
      'search': {
        'orderNo': 'Order Number',
        'memberAccount': 'Member Account',
        'currency': 'Currency',
        'orderStatus': 'Order Status',
        'withdrawType': 'Withdrawal Type',
        'dateType': 'Date Type',
        'startTime': 'Start Time',
        'endTime': 'End Time',
        'search': 'Search',
        'reset': 'Reset'
      },
      'table': {
        'orderNo': 'Order Number',
        'memberAccount': 'Member Account',
        'withdrawType': 'Withdrawal Type',
        'withdrawInfo':'Account information',
        'bankAccount':'Bank account name',
        'bankNumber':'Bank card number',
        'bankName':'Bank name',
        'usdtAccount':'USDT address',
        'usdtType':'USDT chain type',
        'usdtRate':'USDT exchange rate',
        'walletRealName':'Wallet real name',
        'walletAccount':'Wallet account number',
        'currency': 'Currency',
        'amount': 'Amount',
        'fee': 'Fee',
        'realAmount': 'Real Amount',
        'orderStatus': 'Order Status',
        'applyTime': 'Apply Time',
        'operation': 'Operation',
        'riskReason': 'Risk Reason'
      },
      'riskReason': {
        'vipLevelMatch': 'VIP level match risk rule - flagged',
        'gameArbitrageNoDeposit': 'Game arbitrage risk - No deposit user risk rule - flagged',
        'gameArbitrageFirstDeposit': 'Game arbitrage risk - First deposit user risk rule - flagged',
        'gameArbitrageDeviceIp': 'Game arbitrage risk - Device/IP risk rule - flagged',
      },
      'status': {
        'pending': 'Pending',
        'processing': 'Processing',
        'success': 'Approved',
        'rejected': 'Rejected',
        'paying': 'Paying on behalf of',
        'locked': 'Withdrawal locked',
        'riskLocked': 'Locked for review',
      },
      'message': {
        'fetchFailed': 'Failed to fetch data',
        'updateSuccess': 'Update successful',
        'updateFailed': 'Update failed'
      },
      'button': {
        'approve': 'Approve',
        'reject': 'Reject',
        'lock': 'Lock',
        'unlock': 'Unlock',
        'adminUnlock': 'Admin unlock'
      },
      'confirm': {
        'title':'Confirm Operation',
        'approve': 'Are you sure to approve this withdrawal?',
        'reject': 'Are you sure to reject this withdrawal?',
        'lock': 'Are you sure to lock this withdrawal?',
        'unlock': 'Are you sure to unlock this withdrawal?'
      },
      'reject': {
        'reason': 'Reject Reason',
        'reasonRequired': 'Please enter reject reason',
        'reasonPlaceholder': 'Please enter reject reason'
      },
      'lock': {
        'reason': 'Lock Reason',
        'reasonRequired': 'Please enter lock reason',
        'reasonPlaceholder': 'Please enter lock reason'
      },
      'unlock': {
        'reason': 'Unlock Reason',
        'reasonRequired': 'Please enter unlock reason',
        'reasonPlaceholder': 'Please enter unlock reason'
      },
      'detail': {
        'title': 'Withdrawal Details',
        'basicInfo': 'Basic Information',
        'riskInfo': 'Risk Information',
        'operationLog': 'Operation Log',
        'memberInfo': 'Member Information',
        'accountInfo': 'Account Information',
        'withdrawInfo': 'Withdrawal Information',
        'riskLevel': 'Risk Level',
        'riskScore': 'Risk Score',
        'riskTags': 'Risk Tags',
        'operationTime': 'Operation Time',
        'operator': 'Operator',
        'operation': 'Operation',
        'remark': 'Remark'
      }
    },
    'blacklistQuery': {
      'title': 'Blacklist Query',
      'name': 'Name',
      'nameRequired': 'Please enter name',
      'namePlaceholder': 'Please enter name (supports partial search)',
      'firstName': 'First Name',
      'middleName': 'Middle Name',
      'lastName': 'Last Name',
      'birthdate': 'Birth Date',
      'source': 'Source',
      'photo': 'Photo',
      'resultTitle': 'Query Results',
      'queryFailedWithCode': 'Query failed, status code: {code}',
      'queryFailed': 'Query failed',
      'unavailable': 'Unavailable',
      'banned': 'Banned',
      'photoAlt': 'Photo'
    },
    'riskReason':{
      'suspected':'Suspected risk control',
      'manualReview':'Manual review mode',
      'depositWithdrawDiffExceed':'Deposit Withdrawal Difference Amount Exceeds',
      'depositWithdrawPercentExceed':'Deposit Withdrawal Percent Exceeds',
      'totalWinLossExceed':'Cumulative Win Loss Exceeds',
      'withdrawAmountExceed':'Applied Withdrawal Amount Exceeds',
      'totalBonusExceed':'Total Bonus Exceeds',
      'bonusDepositRatioExceed':'Preferential deposit ratio exceeds the limit',
      'depositWithdrawBothExceed':'Deposit-withdrawal difference and percentage both exceed the limit',
      'bonusBothExceed':'Total preferential and preferential deposit ratios exceed the limit',
      'noDeposit':'0 deposit amount, freeloader',
      'vipLevelMatch': 'VIP level match risk rule - flagged',
      'gameArbitrageNoDeposit': 'Game arbitrage risk - No deposit user risk rule - flagged',
      'gameArbitrageFirstDeposit': 'Game arbitrage risk - First deposit user risk rule - flagged',
      'gameArbitrageDeviceIp': 'Game arbitrage risk - Device/IP risk rule - flagged',
    }
  }
}
